module.exports = __webpack_public_path__ + "static/media/logo-new-shiny.437bc9bb.png";